module.exports = __webpack_public_path__ + "img/knsu_gallery8.3bdd6afc.jpg";